import { MapPin } from "lucide-react";

export default function Logo({ size = "md", className = "", variant = "dark" }) {
    const dim = size === "lg" ? "h-7 w-7" : size === "sm" ? "h-5 w-5" : "h-6 w-6";
    const text = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
    const color = variant === "light" ? "text-white" : "text-slate-900";
    const pinColor = variant === "light" ? "text-white" : "text-sky-600";

    return (
        <div className={`flex items-center gap-1.5 ${className}`} data-testid="cleany-logo">
            <MapPin
                className={`${dim} ${pinColor}`}
                strokeWidth={2.4}
                fill="currentColor"
                fillOpacity={0.15}
            />
            <span className={`font-display font-bold tracking-tight ${color} ${text}`}>
                Cleany
            </span>
        </div>
    );
}
